// This file was automatically generated from appchart.refpanel.appts.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.appts');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.appts.nextAppt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.apptTime) {
    if (opt_data.isToday) {
      output.append('<span class="el8RightIndent">Today\'s Appt:</span>', (soy.$$escapeHtml(opt_data.apptTime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.apptTime)) : ''));
    } else {
      output.append('<span class="el8RightIndent">Next Appt:</span>');
      el8.template.appchart.refpanel.appts.formattedApptTime(opt_data, output);
    }
  } else {
    output.append('No upcoming appointments');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.appts.lastAppt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.apptTime) {
    output.append('<span class="el8RightIndent">Last Visit:</span>');
    el8.template.appchart.refpanel.appts.formattedApptTime(opt_data, output);
  } else {
    output.append('No documented visits');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.appts.formattedApptTime = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.apptTime) ? (opt_data.isToday) ? 'Today at ' + (soy.$$escapeHtml(opt_data.apptTime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.apptTime)) : '') : (soy.$$escapeHtml(opt_data.apptTime)? el8.service.tz.soyFullDate(soy.$$escapeHtml(opt_data.apptTime)) : '') + ' at ' + (soy.$$escapeHtml(opt_data.apptTime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.apptTime)) : '') : '');
  if (!opt_sb) return output.toString();
};
